export function StatsRow({ stats }) {
  const pct = (n) => (stats.sent ? `${Math.round((n / stats.sent) * 100)}%` : "—");
  const items = [
    { k: "total_leads", label: "Total leads", tone: "text-foreground" },
    { k: "unsent", label: "Not yet emailed", tone: "text-amber-700" },
    { k: "sent", label: "Emails sent", tone: "text-emerald-700" },
    { k: "delivered", label: "Delivered", tone: "text-emerald-700", rate: true },
    { k: "opened", label: "Opened", tone: "text-indigo-700", rate: true },
    { k: "clicked", label: "Clicked", tone: "text-indigo-700", rate: true },
    { k: "bounced", label: "Bounced", tone: "text-rose-700", rate: true },
    { k: "unsubscribed", label: "Unsubscribed", tone: "text-muted-foreground" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-px bg-border border border-border rounded-xl overflow-hidden">
      {items.map((i) => (
        <div key={i.k} className="bg-card p-5" data-testid={`stat-${i.k}`}>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">{i.label}</p>
          <p className={`font-display text-3xl font-bold mt-2 ${i.tone}`}>{stats[i.k] ?? 0}</p>
          {i.rate && <p className="text-[11px] font-mono text-muted-foreground mt-0.5">{pct(stats[i.k] ?? 0)} of sent</p>}
        </div>
      ))}
    </div>
  );
}
